import {
  AppIcon,
  LabeledInput,
  StatusBanner,
} from "../components/InstateamEmployeeComponents";

export default function EmployeeAuthPage({
  form,
  showForgot,
  showPassword,
  isSubmitting,
  statusMessage,
  onClearStatus,
  onFormChange,
  onToggleForgot,
  onTogglePassword,
  onLogin,
  onForgotPassword,
}) {
  return (
    <div className="employee-shell">
      <section className={`employee-auth-card ${showForgot ? "forgot-mode" : ""}`}>
        <div className="employee-auth-right">
          

          <div className="auth-hero-copy">
            <h1>
              Welcome Back!
              <br />
              <span>Employee</span>
            </h1>
            <p>Log in to your account to view your tasks, attendance, leaves and more.</p>
          </div>

          <div className="employee-auth-feature-list">
            <AuthFeature icon="calendarCheck" title="Mark Attendance" text="Track your daily attendance with ease." />
            <AuthFeature icon="plane" title="Manage Leave" text="Apply and track your leave requests." />
            <AuthFeature icon="checkSquare" title="View Tasks" text="Stay updated with your assigned tasks." />
          </div>

          <div className="employee-lounge-scene" aria-hidden="true">
            <span className="employee-wall-light" />
            <span className="employee-hanging-lamp" />
            <span className="employee-lounge-chair" />
            <span className="employee-lounge-plant" />
            <span className="employee-floor-shadow" />
          </div>
        </div>

        <div className="employee-auth-left">
          <div className="login-panel-card">
            {!showForgot ? (
              <>
                <div className="login-panel-icon">
                  <AppIcon name="user" />
                </div>

                <div className="login-panel-heading">
                  <h1>Employee Login</h1>
                  <p>Sign in to your employee account</p>
                </div>

                {statusMessage ? (
                  <StatusBanner
                    type={statusMessage.type}
                    text={statusMessage.text}
                    onClose={onClearStatus}
                  />
                ) : null}

                <form className="employee-auth-form" onSubmit={onLogin}>
                  <LabeledInput
                    label="Employee ID / Email / Mobile"
                    icon="user"
                    value={form.username}
                    onChange={(value) => onFormChange((current) => ({ ...current, username: value }))}
                    placeholder="Enter employee ID, email or mobile"
                  />

                  <LabeledInput
                    label="Password"
                    icon="lock"
                    type={showPassword ? "text" : "password"}
                    value={form.password}
                    onChange={(value) => onFormChange((current) => ({ ...current, password: value }))}
                    placeholder="Enter your password"
                    trailingButton={
                      <button className="field-icon-button" type="button" onClick={onTogglePassword}>
                        <AppIcon name={showPassword ? "eyeOff" : "eye"} />
                      </button>
                    }
                  />

                  {/* <div className="auth-row">
                    <label className="remember-me">
                      <input
                        type="checkbox"
                        checked={form.rememberMe}
                        onChange={(event) =>
                          onFormChange((current) => ({
                            ...current,
                            rememberMe: event.target.checked,
                          }))
                        }
                      />
                      <span>Remember me</span>
                    </label>

                    <button className="link-button" type="button" onClick={() => onToggleForgot(true)}>
                      Forgot Password?
                    </button>
                  </div> */}

                  <button className="primary-button full-width" type="submit">
                    <AppIcon name="logIn" />
                    {isSubmitting ? "Signing In..." : "Login"}
                  </button>
                </form>
              </>
            ) : (
              <>
                <div className="login-panel-icon">
                  <AppIcon name="shieldLock" />
                </div>
                <div className="login-panel-heading">
                  <h1>Forgot Password?</h1>
                  <p>Enter your registered email address and we will guide you back in.</p>
                </div>

                {statusMessage ? (
                  <StatusBanner
                    type={statusMessage.type}
                    text={statusMessage.text}
                    onClose={onClearStatus}
                  />
                ) : null}

                <form className="employee-auth-form" onSubmit={onForgotPassword}>
                  <LabeledInput
                    label="Email Address"
                    icon="mail"
                    value={form.forgotEmail}
                    onChange={(value) =>
                      onFormChange((current) => ({ ...current, forgotEmail: value }))
                    }
                    placeholder="Enter your registered email"
                  />

                  <button className="primary-button full-width" type="submit">
                    Send Reset Link
                  </button>
                </form>

                <button className="secondary-button full-width" type="button" onClick={() => onToggleForgot(false)}>
                  Back to Login
                </button>
              </>
            )}

            <p className="employee-footer">
              © 2026 InstaTeam. All rights reserved.
              <br />
              v1.0.0
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

function AuthFeature({ icon, title, text }) {
  return (
    <div className="employee-auth-feature">
      <div>
        <AppIcon name={icon} />
      </div>
      <span>
        <strong>{title}</strong>
        <small>{text}</small>
      </span>
    </div>
  );
}
